<template>
  <div>
    <v-app class="p-4">
      <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
        <!--      start edit mode -->
        <template>
          <v-row justify="center">
            <v-dialog
                v-model="dialog"
                max-width="700px"
                transition="dialog-bottom-transition"
            >
              <v-card>
                <v-toolbar
                    dark
                    color="primary">
                  <v-btn
                      icon
                      dark
                      @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>ویرایش</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn
                        dark
                        text
                        @click="dialog = false"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <div class="col-md mt-5 py-0">
                  <v-text-field outlined
                                label="کلمه کلیدی" clearable
                                clear-icon="mdi-close-circle-outline"
                                dense
                                v-model="defaultData.keyword"
                                prepend-inner-icon="fa fa-pencil-alt">

                  </v-text-field>
                </div>
                <div class="col-md my-0 py-0">
                  <v-text-field outlined min="1"
                                oninput="if(Number(this.value) < Number(this.min)) this.value = this.min;"
                                label="عنوان" dense clearable clear-icon="mdi-close-circle-outline"
                                v-model="defaultData.title"
                                prepend-inner-icon="fa fa-pencil-alt">

                  </v-text-field>
                </div>
                <div class="col-md my-0 py-0">
                  <v-textarea outlined min="1" rows="4"
                              oninput="if(Number(this.value) < Number(this.min)) this.value = this.min;"
                              label="توضیحات" dense clearable clear-icon="mdi-close-circle-outline"
                              prepend-inner-icon="mdi-emoticon"
                              @click:prepend-inner="mojiShow = true"
                              v-model="defaultData.description"
                              name="description"
                  >

                  </v-textarea>
                  <v-sheet v-if="mojiShow === true" class="mb-1" color="white lighten-3"
                           outlined
                           rounded>
                    <v-card-text class="py-0 my-0" style="background-color: rgba(255,255,255,0.45)">
                      <button type="button" v-for="item in descEmojies"
                              class="btn my-1  align-content-center py-1"
                              @click="emojiPickerdesc"
                              :data-emoji="item">{{ item }}
                      </button>
                    </v-card-text>
                    <v-btn color="error" text @click="mojiShow = false"><i
                        class="fa fa-times text-danger"></i></v-btn>
                  </v-sheet>
                </div>
                <div class="row mx-auto pb-3 text-center">
                  <div class="col-md-4">
                    <v-btn class="mx-auto text-white btn-refund"
                           @click="refund(defaultData.id)">
                      <span class="fa fa-recycle ml-1" style="font-size: 1.3rem"></span>
                      بازگشت وجه به کاربر
                    </v-btn>
                  </div>

                  <div class="col-md-4">
                    <v-btn class="mx-auto text-white submit-btn"
                           @click="approve(defaultData.id)">
                      <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                      تایید مترادف
                    </v-btn>
                  </div>

                  <div class="col-md-4">
                    <v-btn class="mx-auto btn-report" @click="renew(defaultData.id)">
                      <span class="fa fa-info-circle ml-1" style="font-size: 1.3rem"></span>
                      بررسی مجدد
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
        <!--      end edit mode -->
        <div class="mt-5 pt-5">
          <div class="mt-5 pt-5">
            <p class="text-muted">توجه!: برای تعیین وضعیت آگهی موردنظر روی سطر همان آگهی کلیک کنید!</p>

            <v-card :loading="loading" class="p-3 pt-0">

              <terminal-table class="col-12" :currentPage="data.current_page"
                              :perPage="data.per_page" v-if="isMobile" :getData="getDataForTable"
                              :pageCount="data.last_page"
                              :options="tableProps" :datas="data" :headers="columns"></terminal-table>

              <data-table
                  v-else
                  :data="data"
                  :columns="columns"
                  :debounce-delay="3000"
                  :translate="translate"
                  :orderBy="tableProps.column"
                  :orderDir="tableProps.dir"
                  :pagination="paginate"
                  :per-page="[10, 25, 50, 100, 500]"
                  @on-table-props-changed="reloadTable"
                  :loading="true"
                  @row-clicked="showInfo($event)"
                  class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
              >
                <template slot="filters" slot-scope="{ tableFilters, perPage }">
                  <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                                 v-model="searchBox"></filters-table>
                </template>
              </data-table>
            </v-card>
          </div>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import {dataTableProps} from "@/main";
import button from "@/view/pages/button";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import Swal from "sweetalert2";
import {debounce} from "../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "def",
  components: {FiltersTable, TitleRibbon},
  data() {
    return {
      dialog: false,
      mojiShow: false,
      loading: false,
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      chargeMount: '',
      numbersInfo: false,
      selectedNumber: [],
      descEmojies: ["✌️", "✅", "♻️", "❎", "✳️", "❇️", "✔️", "☑️", "⚫", "⚪", "▪️", "▫️", "◾", "◽", "◼️", "◻️", "⬛", "⬜", "♾️", "✖️", "➗", "➖", "➕", "↩️", "↪️", "⤵️", "⤴️", "↔️", "↕️", "↖️", "↙️",
        "↘️", "↗️", "⬇️", "⬆️", "⬅️", "➡️", "◀️", "⏬", "⏫", "⏪", "⏩", "*️⃣", "#️⃣"],
      defaultData: {},
      dataId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'کاربر',
          name: 'user.name',
          primary: true,
          transform(val) {
            return val.data.user.name + ' ' + val.data.user.lastName
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'موضوع',
          name: 'data.advertise.title',
          orderable: true,
          searchable: true,
        },
        {
          label: 'وضعیت',
          name: 'status',
          primary: true,
          transform(val) {
            const type = {
              hidden: 'تایید نشده',
              paid: 'منتظر پرداخت',
              rejected: 'رد شده',
              enabled: 'فعال',
              disabled: 'غیرفعال ( آگهی ارسال شده)',
              renew: 'بازبینی',
            };
            const kind = {
              hidden: '#EF5350',
              paid: '#FDA4AF',
              rejected: '#FDE047',
              enabled: '#86EFAC',
              disabled: '#CBD5E1',
              renew: '#FFAB91',
            }
            return `<span class="badge text-dark badge-primary text-white" style="background-color: ${kind[val.data.status]}">${type[val.data.status]}</span>`
          },
          orderable: true,
        },
      ],
      data: {},
      url: `${url}/admin/monitoring/default`,
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: query,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.data = data.data;
          vm.loading = false;
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 700);
    },
    showInfo: function (val) {
      this.dialog = true;
      this.defaultData = {
        id: val.id,
        'keyword': val.keyword,
        'title': val.data.advertise.title,
        'description': val.data.advertise.description,
      }
    },
    refund: function (id) {
      $.ajax({
        url: `${url}/refund/${id}`,
        type: 'DELETE',
        fn: this.refund,
        params: [id],
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token
        },
        msg: true,
        success: function (res) {
          this.reloadTable();
        }
      })
    },
    renew: function (id) {
      $.ajax({
        url: `${url}/admin/monitoring/default/renew/${id}`,
        type: 'POST',
        fn: this.renew,
        params: [id],
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token
        },
        msg: true,
        success: function (res) {
          this.reloadTable();
        }
      })
    },
    approve: function (id) {
      $.ajax({
        url: `${url}/admin/monitoring/default/approve/${id}`,
        type: 'POST',
        fn: this.approve,
        params: [id],
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token
        },
        msg: true,
        success: function (res) {
          this.reloadTable();
        }
      })
    },
    emojiPickerdesc(element) {
      const $title = $('[name = "description"]')[0];

      let currentInput = $title.value;
      let cursorPos = $title.selectionStart;
      let textBefore = currentInput.substring(0, cursorPos);
      let textAfter = currentInput.substring(cursorPos, currentInput.length);

      $title.value = textBefore + $(element.target).data("emoji") + textAfter;
      this.defaultData.description = $title.value;

      this.$nextTick(function () {
        $title.focus();
        $title.setSelectionRange(cursorPos, cursorPos);
      })
    },
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url)

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    })
  },
}
</script>

<style scoped>

</style>